/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[disabled][_ngcontent-%COMP%]{background-color:#d7d7d7!important;background-color:var(--customLightGrey)!important}"];
export { styles as styles };
